/**
 * color-swatch-popup.js
 * Koleksiyon sayfası: Renk swatch tıklama + +N popup slider
 */

(function () {
  'use strict';

  /* ─── Sabitler ─── */
  const CARDS_VISIBLE = 3;
  const CARD_GAP_PX   = 10;

  /* ─── Alt duyuru / sticky barının yüksekliğini CSS değişkenine yaz ─── */
  function syncBottomBarHeight() {
    const bar = document.querySelector(
      '.announcement-bar--bottom, .bottom-bar, .footer-bar, [data-bottom-bar], [data-announcement-bar-bottom]'
    );
    const h = bar ? bar.offsetHeight : 48;
    document.documentElement.style.setProperty('--bottom-bar-height', h + 'px');
  }

  syncBottomBarHeight();
  window.addEventListener('resize', syncBottomBarHeight);

  /* ─── Yardımcı: kaydırma miktarını hesapla ─── */
  function getSlideAmount(track) {
    const card = track.querySelector('.csp-popup__card');
    if (!card) return 0;
    return card.offsetWidth + CARD_GAP_PX;
  }

  /* ─── Popup açma ─── */
  function openPopup(productId) {
    const popup = document.getElementById(`csp-popup-${productId}`);
    if (!popup) return;

    popup.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';

    const track = popup.querySelector('[data-track]');
    if (track) {
      track.style.transform = 'translateX(0)';
      track.dataset.currentIndex = '0';
      updateArrows(popup);
    }

    const closeBtn = popup.querySelector('.csp-popup__close');
    if (closeBtn) setTimeout(() => closeBtn.focus(), 60);
  }

  /* ─── Popup kapama ─── */
  function closePopup(popup) {
    popup.setAttribute('hidden', '');
    document.body.style.overflow = '';
  }

  /* ─── Ok görünürlüğünü güncelle ─── */
  function updateArrows(popup) {
    const track  = popup.querySelector('[data-track]');
    const prev   = popup.querySelector('.csp-popup__arrow--prev');
    const next   = popup.querySelector('.csp-popup__arrow--next');
    if (!track || !prev || !next) return;

    const cards      = track.querySelectorAll('.csp-popup__card');
    const total      = cards.length;
    const currentIdx = parseInt(track.dataset.currentIndex || '0', 10);

    prev.hidden = currentIdx <= 0;
    next.hidden = currentIdx + CARDS_VISIBLE >= total;
  }

  /* ─── Slider kaydır ─── */
  function slide(popup, direction) {
    const track = popup.querySelector('[data-track]');
    if (!track) return;

    const cards      = track.querySelectorAll('.csp-popup__card');
    const total      = cards.length;
    let   currentIdx = parseInt(track.dataset.currentIndex || '0', 10);

    if (direction === 'prev') {
      currentIdx = Math.max(0, currentIdx - CARDS_VISIBLE);
    } else {
      currentIdx = Math.min(total - CARDS_VISIBLE, currentIdx + CARDS_VISIBLE);
    }

    track.dataset.currentIndex = currentIdx;
    const offset = getSlideAmount(track) * currentIdx;
    track.style.transform = `translateX(-${offset}px)`;

    updateArrows(popup);
  }

  /* ─── Swiper slider'ı seçilen rengin görselleriyle rebuild et ─── */
  function updateCardSlider(sliderEl, color, fallbackSrc, productUrl) {
    let colorImages = [];
    try {
      const data = JSON.parse(sliderEl.dataset.colorSlides || '{}');
      colorImages = (data.colors && data.colors[color]) || [];
    } catch (e) { /* veri bozuksa fallback'e düş */ }

    /* Rengin kendi görseli yoksa swatch'ın tek görseliyle göster —
       önceki rengin slaytları asla ekranda kalmasın */
    const allImages = colorImages.length ? colorImages : (fallbackSrc ? [fallbackSrc] : []);
    if (!allImages.length) return;

    const wrapper        = sliderEl.querySelector('.swiper-wrapper');
    if (!wrapper) return;

    /* Mevcut style ve media-size class'ını koru */
    const existingImg    = sliderEl.querySelector('.swiper-slide img');
    const styleStr       = existingImg ? (existingImg.getAttribute('style') || '') : '';
    const mediaParent    = sliderEl.parentElement;
    const mediaMatch     = mediaParent ? mediaParent.className.match(/media--(landscape|portrait|square)/) : null;
    const mediaSizeClass = mediaMatch ? mediaMatch[0] : '';

    /* Slide'ları yeniden oluştur */
    wrapper.innerHTML = allImages.map((src, i) =>
      `<div class="swiper-slide media media--transparent ${mediaSizeClass}">` +
        `<img src="${src}" loading="lazy"` +
          ` class="motion-reduce ${i === 0 ? 'media--first' : 'media--second'}"` +
          ` style="${styleStr}" alt="">` +
        `<a href="${productUrl}" class="link link--overlay card-wrapper__link--overlay" aria-label=""></a>` +
      `</div>`
    ).join('');

    /* Swiper destroy + reinit */
    if (sliderEl.swiper && !sliderEl.swiper.destroyed) {
      sliderEl.swiper.destroy(true, true);
    }
    if (typeof Swiper !== 'undefined') {
      new Swiper(sliderEl, {
        pagination: {
          el: sliderEl.querySelector('.product-pagination .swiper-pagination'),
          clickable: true,
        },
        navigation: {
          nextEl: sliderEl.querySelector('.product-button-group.button-next .swiper-button-next'),
          prevEl: sliderEl.querySelector('.product-button-group.button-prev .swiper-button-prev'),
        },
        allowTouchMove: true,
        breakpoints: { 990: { allowTouchMove: false } },
      });
    }
  }

  /* ─── Inline swatch tıklama: görsel/URL güncelle ─── */
  function handleSwatchClick(btn) {
    const wrapper    = btn.closest('.csp-swatch-wrapper');
    const card       = btn.closest('.collection-product-card');
    if (!wrapper) return;

    const variantId  = btn.dataset.variantId;
    const productUrl = btn.dataset.productUrl;
    const imageSrc   = btn.dataset.imageSrc;
    const imageAlt   = btn.dataset.imageAlt;

    /* Aktif swatch güncelle */
    wrapper.querySelectorAll('.csp-swatch').forEach(s => s.classList.remove('csp-swatch--active'));
    btn.classList.add('csp-swatch--active');

    const colorValue = btn.dataset.color || btn.dataset.value || btn.getAttribute('aria-label') || '';
    const prefixRoot = btn.closest('.card-wrapper') || card;
    const prefix = prefixRoot ? prefixRoot.querySelector('[data-card-color-prefix]') : null;
    if (prefix && colorValue) prefix.textContent = colorValue.toUpperCase() + ' ';

    if (card) {
      const sliderEl = card.querySelector('.product-card-js');

      if (sliderEl) {
        /* ── SLIDER MODU: slide'ları varyanta göre rebuild et ── */
        updateCardSlider(sliderEl, btn.dataset.color, imageSrc, productUrl);
      } else {
        /* ── NORMAL MOD: tek görseli doğrudan güncelle ── */
        const img = card.querySelector(
          '.card__media img, .product-card__image img, .card-media img, .media img, img.card__image'
        );
        if (img && imageSrc) {
          img.src    = imageSrc;
          img.srcset = '';
          if (imageAlt) img.alt = imageAlt;
        }
      }

      /* Ürün linklerini her iki modda da güncelle */
      card.querySelectorAll('a[href*="/products/"]').forEach(a => {
        if (productUrl) a.href = productUrl;
      });
    }
  }

  /* ─── Dokunmatik / swipe desteği ─── */
  function addSwipeSupport(popup) {
    const track = popup.querySelector('[data-track]');
    if (!track || popup.dataset.ntSwipeBound === 'true') return;
    popup.dataset.ntSwipeBound = 'true';

    let startX     = 0;
    let isDragging = false;

    track.addEventListener('pointerdown', e => {
      startX     = e.clientX;
      isDragging = true;
    });

    track.addEventListener('pointerup', e => {
      if (!isDragging) return;
      isDragging = false;
      const diff = startX - e.clientX;
      if (Math.abs(diff) > 40) {
        slide(popup, diff > 0 ? 'next' : 'prev');
      }
    });

    track.addEventListener('pointercancel', () => { isDragging = false; });
  }

  /* ─── Klavye desteği ─── */
  function handleKeydown(e) {
    if (e.key === 'Escape') {
      const openPopup = document.querySelector('.csp-popup:not([hidden])');
      if (openPopup) closePopup(openPopup);
    }
  }

  /* ─── Olayları bağla ─── */
  function bindEvents() {
    document.addEventListener('click', function (e) {

      /* +N butonu → popup aç */
      const moreBtn = e.target.closest('.csp-more-btn');
      if (moreBtn) {
        e.preventDefault();
        e.stopPropagation();
        openPopup(moreBtn.dataset.productId);
        return;
      }

      /* Inline swatch */
      const swatchBtn = e.target.closest('.csp-swatch');
      if (swatchBtn) {
        e.preventDefault();
        e.stopPropagation();
        handleSwatchClick(swatchBtn);
        return;
      }

      const legacySwatch = e.target.closest('[data-value], [data-color], .js-color-swatches button, .color-swatch');
      if (legacySwatch) {
        const wrap = legacySwatch.closest('.card-wrapper');
        const colorValue = legacySwatch.dataset.value || legacySwatch.dataset.color || legacySwatch.getAttribute('aria-label') || '';
        const prefix = wrap ? wrap.querySelector('[data-card-color-prefix]') : null;
        if (prefix && colorValue) prefix.textContent = colorValue.toUpperCase() + ' ';
      }

      /* Popup'taki ürün kartı */
      const popupCard = e.target.closest('.csp-popup__card');
      if (popupCard) {
        const popup = popupCard.closest('.csp-popup');
        if (popup) closePopup(popup);
        return;
      }

      /* Kapat butonu */
      const closeBtn = e.target.closest('.csp-popup__close');
      if (closeBtn) {
        const popup = closeBtn.closest('.csp-popup');
        if (popup) closePopup(popup);
        return;
      }

      /* Backdrop tıklaması */
      const backdrop = e.target.closest('.csp-popup__backdrop');
      if (backdrop) {
        const popup = backdrop.closest('.csp-popup');
        if (popup) closePopup(popup);
        return;
      }

      /* Ok butonları */
      const arrowBtn = e.target.closest('.csp-popup__arrow');
      if (arrowBtn) {
        e.preventDefault();
        const popup = arrowBtn.closest('.csp-popup');
        if (popup) {
          slide(popup, arrowBtn.classList.contains('csp-popup__arrow--prev') ? 'prev' : 'next');
        }
        return;
      }
    });

    document.addEventListener('keydown', handleKeydown);

    document.querySelectorAll('.csp-popup').forEach(addSwipeSupport);
  }

  /* ─── Başlat ─── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindEvents);
  } else {
    bindEvents();
  }

  /* ─── Infinite scroll / AJAX sayfa yükleme desteği ─── */
  const observer = new MutationObserver(mutations => {
    mutations.forEach(m => {
      m.addedNodes.forEach(node => {
        if (node.nodeType !== 1) return;
        if (node.classList.contains('csp-popup')) addSwipeSupport(node);
        node.querySelectorAll('.csp-popup').forEach(addSwipeSupport);
      });
    });
  });

  const observeRoot = document.getElementById('MainContent') || document.body;
  observer.observe(observeRoot, { childList: true, subtree: true });

})();